var map = {
	"./App": [
		9652,
		9
	],
	"./App.vue": [
		9652,
		9
	],
	"./assets/Ensu-logo.png": [
		2353,
		1
	],
	"./assets/css/tailwind.css": [
		1609,
		9,
		1609
	],
	"./assets/css/theme.css": [
		6294,
		9,
		6294
	],
	"./assets/logo-orange.svg": [
		4446,
		1,
		4446
	],
	"./assets/logo.png": [
		3153,
		1,
		3153
	],
	"./assets/us-flag.svg": [
		2301,
		1,
		2301
	],
	"./components/NotificationBadge": [
		9421,
		9
	],
	"./components/NotificationBadge.vue": [
		9421,
		9
	],
	"./components/TableView": [
		4141,
		9,
		4141
	],
	"./components/TableView.vue": [
		4141,
		9,
		4141
	],
	"./components/WaiterDashboard": [
		4568,
		9,
		4568
	],
	"./components/WaiterDashboard.vue": [
		4568,
		9,
		4568
	],
	"./components/admin/Category/CategoryFormModal": [
		8880,
		9,
		8880
	],
	"./components/admin/Category/CategoryFormModal.vue": [
		8880,
		9,
		8880
	],
	"./components/admin/Category/CategoryList": [
		9194,
		9,
		9194
	],
	"./components/admin/Category/CategoryList.vue": [
		9194,
		9,
		9194
	],
	"./components/admin/CategoryFormModal": [
		8969,
		9,
		8969
	],
	"./components/admin/CategoryFormModal.vue": [
		8969,
		9,
		8969
	],
	"./components/admin/ChartCard": [
		5198,
		9,
		5198
	],
	"./components/admin/ChartCard.vue": [
		5198,
		9,
		5198
	],
	"./components/admin/DashboardCard": [
		7986,
		9,
		7986
	],
	"./components/admin/DashboardCard.vue": [
		7986,
		9,
		7986
	],
	"./components/admin/DashboardChartDetailModal": [
		9456,
		9,
		8436,
		8924,
		9456,
		9585
	],
	"./components/admin/DashboardChartDetailModal.vue": [
		9456,
		9,
		8436,
		8924,
		9456,
		9585
	],
	"./components/admin/DeleteConfirmationModal": [
		3559,
		9,
		3559
	],
	"./components/admin/DeleteConfirmationModal.vue": [
		3559,
		9,
		3559
	],
	"./components/admin/Order/OrderCard": [
		4953,
		9,
		4953
	],
	"./components/admin/Order/OrderCard.vue": [
		4953,
		9,
		4953
	],
	"./components/admin/Order/OrderDetailModal": [
		2934,
		9,
		2934
	],
	"./components/admin/Order/OrderDetailModal.vue": [
		2934,
		9,
		2934
	],
	"./components/admin/Order/OrderGroup": [
		2532,
		9,
		2532,
		9246
	],
	"./components/admin/Order/OrderGroup.vue": [
		2532,
		9,
		2532,
		9246
	],
	"./components/admin/Order/OrderManagement": [
		9441,
		9,
		9441
	],
	"./components/admin/Order/OrderManagement.vue": [
		9441,
		9,
		9441
	],
	"./components/admin/hotel/BaseModal": [
		2248,
		9,
		2248
	],
	"./components/admin/hotel/BaseModal.vue": [
		2248,
		9,
		2248
	],
	"./components/admin/hotel/FeatureToggle": [
		221,
		9,
		221
	],
	"./components/admin/hotel/FeatureToggle.vue": [
		221,
		9,
		221
	],
	"./components/admin/hotel/Field": [
		8570,
		9,
		8570
	],
	"./components/admin/hotel/Field.vue": [
		8570,
		9,
		8570
	],
	"./components/admin/hotel/FilterTab": [
		3397,
		9,
		3397
	],
	"./components/admin/hotel/FilterTab.vue": [
		3397,
		9,
		3397
	],
	"./components/admin/hotel/KpiTile": [
		1078,
		9,
		1078
	],
	"./components/admin/hotel/KpiTile.vue": [
		1078,
		9,
		1078
	],
	"./components/admin/hotel/ModeCard": [
		3220,
		9,
		839
	],
	"./components/admin/hotel/ModeCard.vue": [
		3220,
		9,
		839
	],
	"./components/admin/hotel/OrderCardV2": [
		8945,
		9,
		8945
	],
	"./components/admin/hotel/OrderCardV2.vue": [
		8945,
		9,
		8945
	],
	"./components/admin/hotel/OrderDetailDrawer": [
		5242,
		9,
		5242
	],
	"./components/admin/hotel/OrderDetailDrawer.vue": [
		5242,
		9,
		5242
	],
	"./components/admin/hotel/QrCode": [
		1642,
		9,
		8420,
		1642
	],
	"./components/admin/hotel/QrCode.vue": [
		1642,
		9,
		8420,
		1642
	],
	"./components/admin/hotel/RoomStatusPill": [
		7821,
		9,
		7821
	],
	"./components/admin/hotel/RoomStatusPill.vue": [
		7821,
		9,
		7821
	],
	"./components/admin/hotel/StatChip": [
		3067,
		9,
		3067
	],
	"./components/admin/hotel/StatChip.vue": [
		3067,
		9,
		3067
	],
	"./components/admin/waiter/TableCard": [
		6408,
		9,
		6408
	],
	"./components/admin/waiter/TableCard.vue": [
		6408,
		9,
		6408
	],
	"./components/charts/DoughnutChart": [
		1545,
		9,
		8436,
		1545
	],
	"./components/charts/DoughnutChart.vue": [
		1545,
		9,
		8436,
		1545
	],
	"./components/charts/LineChart": [
		6132,
		9,
		8436,
		8924,
		6132
	],
	"./components/charts/LineChart.vue": [
		6132,
		9,
		8436,
		8924,
		6132
	],
	"./components/charts/RadarChart": [
		7422,
		9,
		8436,
		7422
	],
	"./components/charts/RadarChart.vue": [
		7422,
		9,
		8436,
		7422
	],
	"./components/common/LanguageSwitcher": [
		5722,
		9
	],
	"./components/common/LanguageSwitcher.vue": [
		5722,
		9
	],
	"./components/common/ThemeToggle": [
		9318,
		9
	],
	"./components/common/ThemeToggle.vue": [
		9318,
		9
	],
	"./components/customer/AllergenBadges": [
		9496,
		9,
		9496
	],
	"./components/customer/AllergenBadges.vue": [
		9496,
		9,
		9496
	],
	"./components/customer/AllergyConfirmModal": [
		9616,
		9,
		9616
	],
	"./components/customer/AllergyConfirmModal.vue": [
		9616,
		9,
		9616
	],
	"./components/customer/OrderExtender": [
		8015,
		9,
		8015
	],
	"./components/customer/OrderExtender.vue": [
		8015,
		9,
		8015
	],
	"./components/customer/OrderModificationPanel": [
		4123,
		9,
		4123
	],
	"./components/customer/OrderModificationPanel.vue": [
		4123,
		9,
		4123
	],
	"./components/customer/PaymentMethodSelector": [
		7360,
		9,
		7360,
		4278
	],
	"./components/customer/PaymentMethodSelector.vue": [
		7360,
		9,
		7360,
		4278
	],
	"./components/customer/ProductSelectionModal": [
		9469,
		9,
		9469
	],
	"./components/customer/ProductSelectionModal.vue": [
		9469,
		9,
		9469
	],
	"./components/customer/RoomChargeModal": [
		8523,
		9,
		8523
	],
	"./components/customer/RoomChargeModal.vue": [
		8523,
		9,
		8523
	],
	"./components/gamification/AdminBattleRoyale": [
		7717,
		9,
		7717
	],
	"./components/gamification/AdminBattleRoyale.vue": [
		7717,
		9,
		7717
	],
	"./components/gamification/AdminGamificationSettings": [
		9787,
		9,
		9787
	],
	"./components/gamification/AdminGamificationSettings.vue": [
		9787,
		9,
		9787
	],
	"./components/gamification/AiChatbot": [
		7032,
		9
	],
	"./components/gamification/AiChatbot.vue": [
		7032,
		9
	],
	"./components/gamification/BattleRoyale": [
		5509,
		9
	],
	"./components/gamification/BattleRoyale.vue": [
		5509,
		9
	],
	"./components/gamification/BillRoulette": [
		6981,
		9
	],
	"./components/gamification/BillRoulette.vue": [
		6981,
		9
	],
	"./components/gamification/FlambeGame": [
		8417,
		9,
		8417
	],
	"./components/gamification/FlambeGame.vue": [
		8417,
		9,
		8417
	],
	"./components/gamification/FoodTinder": [
		7856,
		9
	],
	"./components/gamification/FoodTinder.vue": [
		7856,
		9
	],
	"./components/gamification/GameHub": [
		6366,
		9
	],
	"./components/gamification/GameHub.vue": [
		6366,
		9
	],
	"./components/gamification/GameReward": [
		2307,
		9
	],
	"./components/gamification/GameReward.vue": [
		2307,
		9
	],
	"./components/gamification/GoldenPourGame": [
		2448,
		9
	],
	"./components/gamification/GoldenPourGame.vue": [
		2448,
		9
	],
	"./components/gamification/GuestOnboarding": [
		8621,
		9,
		8621
	],
	"./components/gamification/GuestOnboarding.vue": [
		8621,
		9,
		8621
	],
	"./components/gamification/LuckyWheel": [
		9378,
		9
	],
	"./components/gamification/LuckyWheel.vue": [
		9378,
		9
	],
	"./components/gamification/OrderBlitzGame": [
		8471,
		9
	],
	"./components/gamification/OrderBlitzGame.vue": [
		8471,
		9
	],
	"./components/gamification/PrisonerDilemma": [
		7732,
		9
	],
	"./components/gamification/PrisonerDilemma.vue": [
		7732,
		9
	],
	"./components/gamification/QuizBattle": [
		9116,
		9
	],
	"./components/gamification/QuizBattle.vue": [
		9116,
		9
	],
	"./components/gamification/RushHourGame": [
		6158,
		9
	],
	"./components/gamification/RushHourGame.vue": [
		6158,
		9
	],
	"./components/gamification/SharedCartOverview": [
		5177,
		9,
		5177
	],
	"./components/gamification/SharedCartOverview.vue": [
		5177,
		9,
		5177
	],
	"./components/gamification/SharedProgressBar": [
		6139,
		9
	],
	"./components/gamification/SharedProgressBar.vue": [
		6139,
		9
	],
	"./components/gamification/ShellGame": [
		4406,
		9
	],
	"./components/gamification/ShellGame.vue": [
		4406,
		9
	],
	"./components/gamification/SmartUpsell": [
		4557,
		9,
		4557
	],
	"./components/gamification/SmartUpsell.vue": [
		4557,
		9,
		4557
	],
	"./components/kitchen/KitchenCard": [
		9156,
		9,
		8924,
		9156,
		4232
	],
	"./components/kitchen/KitchenCard.vue": [
		9156,
		9,
		8924,
		9156,
		4232
	],
	"./components/kitchen/KitchenConfirmationModal": [
		7613,
		9,
		7613
	],
	"./components/kitchen/KitchenConfirmationModal.vue": [
		7613,
		9,
		7613
	],
	"./components/kitchen/KitchenFilterTags": [
		1079,
		9,
		1079
	],
	"./components/kitchen/KitchenFilterTags.vue": [
		1079,
		9,
		1079
	],
	"./components/kitchen/KitchenFilters": [
		5458,
		9,
		5458
	],
	"./components/kitchen/KitchenFilters.vue": [
		5458,
		9,
		5458
	],
	"./components/layout/AppHeader": [
		391,
		9
	],
	"./components/layout/AppHeader.vue": [
		391,
		9
	],
	"./components/layout/CustomerHeader": [
		3833,
		9
	],
	"./components/layout/CustomerHeader.vue": [
		3833,
		9
	],
	"./components/layout/NotificationMenu": [
		1317,
		9
	],
	"./components/layout/NotificationMenu.vue": [
		1317,
		9
	],
	"./components/layout/SideNav": [
		8009,
		9
	],
	"./components/layout/SideNav.vue": [
		8009,
		9
	],
	"./components/layout/SideNavOverlay": [
		3491,
		9
	],
	"./components/layout/SideNavOverlay.vue": [
		3491,
		9
	],
	"./components/layout/UserMenu": [
		1460,
		9
	],
	"./components/layout/UserMenu.vue": [
		1460,
		9
	],
	"./components/menu/VerticalCategorySidebar": [
		7464,
		9,
		7464
	],
	"./components/menu/VerticalCategorySidebar.vue": [
		7464,
		9,
		7464
	],
	"./components/superadmin/Restaurants": [
		5890,
		9,
		5890
	],
	"./components/superadmin/Restaurants.vue": [
		5890,
		9,
		5890
	],
	"./components/ui/FormPanel": [
		7289,
		9,
		7289
	],
	"./components/ui/FormPanel.vue": [
		7289,
		9,
		7289
	],
	"./composables/useFormatters": [
		6998,
		9,
		6998
	],
	"./composables/useFormatters.js": [
		6998,
		9,
		6998
	],
	"./composables/useNotifications": [
		2417,
		9
	],
	"./composables/useNotifications.js": [
		2417,
		9
	],
	"./composables/useToast": [
		3366,
		9,
		3366
	],
	"./composables/useToast.js": [
		3366,
		9,
		3366
	],
	"./composables/useWebRTC": [
		8000,
		9
	],
	"./composables/useWebRTC.js": [
		8000,
		9
	],
	"./config": [
		2169,
		9
	],
	"./config.js": [
		2169,
		9
	],
	"./config/api.config": [
		5300,
		9
	],
	"./config/api.config.js": [
		5300,
		9
	],
	"./i18n": [
		8044,
		9
	],
	"./i18n/": [
		8044,
		9
	],
	"./i18n/de": [
		6477,
		3
	],
	"./i18n/de.json": [
		6477,
		3
	],
	"./i18n/en": [
		5553,
		3
	],
	"./i18n/en.json": [
		5553,
		3
	],
	"./i18n/hotel.de": [
		5969,
		3
	],
	"./i18n/hotel.de.json": [
		5969,
		3
	],
	"./i18n/hotel.en": [
		8117,
		3
	],
	"./i18n/hotel.en.json": [
		8117,
		3
	],
	"./i18n/hotel.it": [
		4111,
		3
	],
	"./i18n/hotel.it.json": [
		4111,
		3
	],
	"./i18n/index": [
		8044,
		9
	],
	"./i18n/index.js": [
		8044,
		9
	],
	"./layouts/SuperAdminLayout": [
		1670,
		9,
		1670
	],
	"./layouts/SuperAdminLayout.vue": [
		1670,
		9,
		1670
	],
	"./locales/de": [
		5894,
		3,
		5894
	],
	"./locales/de.json": [
		5894,
		3,
		5894
	],
	"./locales/en": [
		4174,
		3,
		4174
	],
	"./locales/en.json": [
		4174,
		3,
		4174
	],
	"./main": [
		1406,
		9
	],
	"./main.js": [
		1406,
		9
	],
	"./models/Product": [
		9689,
		9,
		9689
	],
	"./models/Product.js": [
		9689,
		9,
		9689
	],
	"./models/RestaurantSettings": [
		3174,
		9
	],
	"./models/RestaurantSettings.js": [
		3174,
		9
	],
	"./navigation/sideNavItems": [
		32,
		9
	],
	"./navigation/sideNavItems.js": [
		32,
		9
	],
	"./router": [
		9325,
		9
	],
	"./router/": [
		9325,
		9
	],
	"./router/index": [
		9325,
		9
	],
	"./router/index.js": [
		9325,
		9
	],
	"./services/api": [
		4300,
		9
	],
	"./services/api.js": [
		4300,
		9
	],
	"./services/api/": [
		2995,
		9
	],
	"./services/api/adminService": [
		1981,
		9
	],
	"./services/api/adminService.js": [
		1981,
		9
	],
	"./services/api/authService": [
		2374,
		9
	],
	"./services/api/authService.js": [
		2374,
		9
	],
	"./services/api/cartService": [
		1134,
		9
	],
	"./services/api/cartService.js": [
		1134,
		9
	],
	"./services/api/categoryService": [
		7536,
		9,
		7536
	],
	"./services/api/categoryService.js": [
		7536,
		9,
		7536
	],
	"./services/api/customerService": [
		7736,
		9
	],
	"./services/api/customerService.js": [
		7736,
		9
	],
	"./services/api/dashboardService": [
		8164,
		9
	],
	"./services/api/dashboardService.js": [
		8164,
		9
	],
	"./services/api/extraOptionService": [
		7169,
		9
	],
	"./services/api/extraOptionService.js": [
		7169,
		9
	],
	"./services/api/gamificationService": [
		2707,
		9
	],
	"./services/api/gamificationService.js": [
		2707,
		9
	],
	"./services/api/hotelService": [
		834,
		9
	],
	"./services/api/hotelService.js": [
		834,
		9
	],
	"./services/api/index": [
		2995,
		9
	],
	"./services/api/index.js": [
		2995,
		9
	],
	"./services/api/instance": [
		6192,
		9
	],
	"./services/api/instance.js": [
		6192,
		9
	],
	"./services/api/kitchenService": [
		768,
		9,
		768
	],
	"./services/api/kitchenService.js": [
		768,
		9,
		768
	],
	"./services/api/orderService": [
		2544,
		9
	],
	"./services/api/orderService.js": [
		2544,
		9
	],
	"./services/api/paymentService": [
		3758,
		9
	],
	"./services/api/paymentService.js": [
		3758,
		9
	],
	"./services/api/printerService": [
		9404,
		9
	],
	"./services/api/printerService.js": [
		9404,
		9
	],
	"./services/api/productService": [
		6701,
		9,
		6701
	],
	"./services/api/productService.js": [
		6701,
		9,
		6701
	],
	"./services/api/productsService": [
		6804,
		9
	],
	"./services/api/productsService.js": [
		6804,
		9
	],
	"./services/api/receiptService": [
		8836,
		9,
		8836
	],
	"./services/api/receiptService.js": [
		8836,
		9,
		8836
	],
	"./services/api/reportService": [
		860,
		9,
		6098
	],
	"./services/api/reportService.js": [
		860,
		9,
		6098
	],
	"./services/api/restaurantSettingsService": [
		1482,
		9
	],
	"./services/api/restaurantSettingsService.js": [
		1482,
		9
	],
	"./services/api/roomChargeService": [
		5097,
		9
	],
	"./services/api/roomChargeService.js": [
		5097,
		9
	],
	"./services/api/sessionService": [
		6876,
		9
	],
	"./services/api/sessionService.js": [
		6876,
		9
	],
	"./services/api/superAdminService": [
		5538,
		9
	],
	"./services/api/superAdminService.js": [
		5538,
		9
	],
	"./services/api/userService": [
		4273,
		9
	],
	"./services/api/userService.js": [
		4273,
		9
	],
	"./services/paymentRequestService": [
		9358,
		9
	],
	"./services/paymentRequestService.js": [
		9358,
		9
	],
	"./services/receiptPrinter": [
		1702,
		9,
		1702
	],
	"./services/receiptPrinter.js": [
		1702,
		9,
		1702
	],
	"./services/waiterCallService": [
		6098,
		9
	],
	"./services/waiterCallService.js": [
		6098,
		9
	],
	"./stores": [
		1570,
		9,
		1570
	],
	"./stores/": [
		1570,
		9,
		1570
	],
	"./stores/auth": [
		14,
		9
	],
	"./stores/auth.js": [
		14,
		9
	],
	"./stores/cart": [
		5934,
		9
	],
	"./stores/cart.js": [
		5934,
		9
	],
	"./stores/gamification": [
		9589,
		9
	],
	"./stores/gamification.js": [
		9589,
		9
	],
	"./stores/helpers/localStorage": [
		5694,
		9,
		5694
	],
	"./stores/helpers/localStorage.js": [
		5694,
		9,
		5694
	],
	"./stores/index": [
		1570,
		9,
		1570
	],
	"./stores/index.js": [
		1570,
		9,
		1570
	],
	"./stores/orders": [
		4621,
		9
	],
	"./stores/orders.js": [
		4621,
		9
	],
	"./stores/products": [
		3216,
		9,
		3216
	],
	"./stores/products.js": [
		3216,
		9,
		3216
	],
	"./stores/restaurant": [
		2939,
		9
	],
	"./stores/restaurant.js": [
		2939,
		9
	],
	"./stores/session": [
		926,
		9,
		926
	],
	"./stores/session.js": [
		926,
		9,
		926
	],
	"./stores/theme": [
		9435,
		9
	],
	"./stores/theme.js": [
		9435,
		9
	],
	"./stores/user": [
		4783,
		9
	],
	"./stores/user.js": [
		4783,
		9
	],
	"./utils/customerGames": [
		8222,
		9
	],
	"./utils/customerGames.js": [
		8222,
		9
	],
	"./utils/domainDetector": [
		9651,
		9,
		9651
	],
	"./utils/domainDetector.js": [
		9651,
		9,
		9651
	],
	"./utils/environmentConfig": [
		4490,
		9
	],
	"./utils/environmentConfig.js": [
		4490,
		9
	],
	"./utils/formatters": [
		9586,
		9,
		9586
	],
	"./utils/formatters.js": [
		9586,
		9,
		9586
	],
	"./utils/helpers": [
		9960,
		9,
		9960
	],
	"./utils/helpers.js": [
		9960,
		9,
		9960
	],
	"./utils/restaurantRegistry": [
		2457,
		9,
		2457
	],
	"./utils/restaurantRegistry.js": [
		2457,
		9,
		2457
	],
	"./views/EntryPointView": [
		6960,
		9,
		6960
	],
	"./views/EntryPointView.vue": [
		6960,
		9,
		6960
	],
	"./views/Home": [
		4308,
		9,
		4308
	],
	"./views/Home.vue": [
		4308,
		9,
		4308
	],
	"./views/NotFound": [
		1101,
		9,
		1101
	],
	"./views/NotFound.vue": [
		1101,
		9,
		1101
	],
	"./views/SessionExpired": [
		8256,
		9,
		8256
	],
	"./views/SessionExpired.vue": [
		8256,
		9,
		8256
	],
	"./views/SessionForbidden": [
		7854,
		9,
		7854
	],
	"./views/SessionForbidden.vue": [
		7854,
		9,
		7854
	],
	"./views/SessionView": [
		7447,
		9,
		7447
	],
	"./views/SessionView.vue": [
		7447,
		9,
		7447
	],
	"./views/admin/BattleRoyaleAdmin": [
		8987,
		9,
		8987
	],
	"./views/admin/BattleRoyaleAdmin.vue": [
		8987,
		9,
		8987
	],
	"./views/admin/Categories": [
		9712,
		9,
		9712
	],
	"./views/admin/Categories.vue": [
		9712,
		9,
		9712
	],
	"./views/admin/Dashboard": [
		7250,
		9,
		8436,
		8924,
		9456,
		652
	],
	"./views/admin/Dashboard.vue": [
		7250,
		9,
		8436,
		8924,
		9456,
		652
	],
	"./views/admin/Extras": [
		6120,
		9,
		6120
	],
	"./views/admin/Extras.vue": [
		6120,
		9,
		6120
	],
	"./views/admin/Gamification": [
		9509,
		9,
		9509
	],
	"./views/admin/Gamification.vue": [
		9509,
		9,
		9509
	],
	"./views/admin/HotelDashboard": [
		9336,
		9,
		8436,
		8924,
		6955
	],
	"./views/admin/HotelDashboard.vue": [
		9336,
		9,
		8436,
		8924,
		6955
	],
	"./views/admin/HotelGroupDashboard": [
		1324,
		9,
		8436,
		8924,
		1324
	],
	"./views/admin/HotelGroupDashboard.vue": [
		1324,
		9,
		8436,
		8924,
		1324
	],
	"./views/admin/HotelGroupUsers": [
		2102,
		9,
		2102
	],
	"./views/admin/HotelGroupUsers.vue": [
		2102,
		9,
		2102
	],
	"./views/admin/HotelLocations": [
		4128,
		9,
		8420,
		4128
	],
	"./views/admin/HotelLocations.vue": [
		4128,
		9,
		8420,
		4128
	],
	"./views/admin/HotelRooms": [
		439,
		9,
		8420,
		439
	],
	"./views/admin/HotelRooms.vue": [
		439,
		9,
		8420,
		439
	],
	"./views/admin/Locations": [
		77,
		9,
		77
	],
	"./views/admin/Locations.vue": [
		77,
		9,
		77
	],
	"./views/admin/OrderDetails": [
		1845,
		9,
		1845
	],
	"./views/admin/OrderDetails.vue": [
		1845,
		9,
		1845
	],
	"./views/admin/Orders": [
		9386,
		9,
		2532,
		8203
	],
	"./views/admin/Orders.vue": [
		9386,
		9,
		2532,
		8203
	],
	"./views/admin/OrdersV2": [
		1390,
		9,
		1390
	],
	"./views/admin/OrdersV2.vue": [
		1390,
		9,
		1390
	],
	"./views/admin/PreOrders": [
		607,
		9,
		607
	],
	"./views/admin/PreOrders.vue": [
		607,
		9,
		607
	],
	"./views/admin/ProductExtras": [
		8366,
		9,
		8366
	],
	"./views/admin/ProductExtras.vue": [
		8366,
		9,
		8366
	],
	"./views/admin/ProductForm": [
		8241,
		9,
		8241
	],
	"./views/admin/ProductForm.vue": [
		8241,
		9,
		8241
	],
	"./views/admin/Products": [
		4144,
		9,
		4144
	],
	"./views/admin/Products.vue": [
		4144,
		9,
		4144
	],
	"./views/admin/Reports": [
		6449,
		9,
		6449
	],
	"./views/admin/Reports.vue": [
		6449,
		9,
		6449
	],
	"./views/admin/RoomCharges": [
		9546,
		9,
		9546
	],
	"./views/admin/RoomCharges.vue": [
		9546,
		9,
		9546
	],
	"./views/admin/Settings": [
		760,
		9,
		760
	],
	"./views/admin/Settings.vue": [
		760,
		9,
		760
	],
	"./views/admin/TableDetail": [
		5609,
		9,
		8420,
		5609
	],
	"./views/admin/TableDetail.vue": [
		5609,
		9,
		8420,
		5609
	],
	"./views/admin/Tables": [
		6336,
		9,
		6336
	],
	"./views/admin/Tables.vue": [
		6336,
		9,
		6336
	],
	"./views/admin/UserForm": [
		6695,
		9,
		6695
	],
	"./views/admin/UserForm.vue": [
		6695,
		9,
		6695
	],
	"./views/admin/Users": [
		7758,
		9,
		7758
	],
	"./views/admin/Users.vue": [
		7758,
		9,
		7758
	],
	"./views/admin/WaiterApp": [
		67,
		9,
		67
	],
	"./views/admin/WaiterApp.vue": [
		67,
		9,
		67
	],
	"./views/admin/WaiterPos": [
		4072,
		9,
		4072
	],
	"./views/admin/WaiterPos.vue": [
		4072,
		9,
		4072
	],
	"./views/auth/Login": [
		1629,
		9,
		1629
	],
	"./views/auth/Login.vue": [
		1629,
		9,
		1629
	],
	"./views/customer/Cart": [
		3280,
		9,
		3280
	],
	"./views/customer/Cart.vue": [
		3280,
		9,
		3280
	],
	"./views/customer/CartView": [
		9961,
		9,
		7360,
		5374
	],
	"./views/customer/CartView.vue": [
		9961,
		9,
		7360,
		5374
	],
	"./views/customer/HomeView": [
		3292,
		9,
		3292
	],
	"./views/customer/HomeView.vue": [
		3292,
		9,
		3292
	],
	"./views/customer/MenuView": [
		4107,
		9,
		4107
	],
	"./views/customer/MenuView.vue": [
		4107,
		9,
		4107
	],
	"./views/customer/OrderStatus": [
		8576,
		9,
		8576
	],
	"./views/customer/OrderStatus.vue": [
		8576,
		9,
		8576
	],
	"./views/customer/PaymentCancelView": [
		9709,
		9,
		9709
	],
	"./views/customer/PaymentCancelView.vue": [
		9709,
		9,
		9709
	],
	"./views/customer/PaymentSuccessView": [
		1540,
		9,
		1540
	],
	"./views/customer/PaymentSuccessView.vue": [
		1540,
		9,
		1540
	],
	"./views/customer/PreOrderView": [
		6599,
		9,
		6599
	],
	"./views/customer/PreOrderView.vue": [
		6599,
		9,
		6599
	],
	"./views/customer/ProductDetailView": [
		3043,
		9,
		3043
	],
	"./views/customer/ProductDetailView.vue": [
		3043,
		9,
		3043
	],
	"./views/customer/RoomEntryView": [
		923,
		9,
		923
	],
	"./views/customer/RoomEntryView.vue": [
		923,
		9,
		923
	],
	"./views/customer/RoomServiceView": [
		9815,
		9,
		9815
	],
	"./views/customer/RoomServiceView.vue": [
		9815,
		9,
		9815
	],
	"./views/kitchen/KitchenView": [
		4569,
		9,
		8924,
		9156,
		752
	],
	"./views/kitchen/KitchenView.vue": [
		4569,
		9,
		8924,
		9156,
		752
	],
	"./views/public/LiveOccupancyEmbed": [
		2190,
		9,
		2190
	],
	"./views/public/LiveOccupancyEmbed.vue": [
		2190,
		9,
		2190
	],
	"./views/superadmin/Dashboard": [
		4885,
		9,
		4885
	],
	"./views/superadmin/Dashboard.vue": [
		4885,
		9,
		4885
	],
	"./views/superadmin/Onboarding": [
		8730,
		9,
		8730
	],
	"./views/superadmin/Onboarding.vue": [
		8730,
		9,
		8730
	],
	"./views/superadmin/RestaurantDetail": [
		901,
		9,
		901
	],
	"./views/superadmin/RestaurantDetail.vue": [
		901,
		9,
		901
	],
	"./views/superadmin/RestaurantForm": [
		839,
		9,
		3220
	],
	"./views/superadmin/RestaurantForm.vue": [
		839,
		9,
		3220
	],
	"./views/superadmin/Restaurants": [
		3276,
		9,
		3276
	],
	"./views/superadmin/Restaurants.vue": [
		3276,
		9,
		3276
	],
	"./views/superadmin/components/RestaurantList": [
		6006,
		9,
		6006
	],
	"./views/superadmin/components/RestaurantList.vue": [
		6006,
		9,
		6006
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9140;
module.exports = webpackAsyncContext;